// ============================================
// ПЕРЕКЛЮЧАТЕЛЬ ЯЗЫКОВ
// ============================================

let currentLang = localStorage.getItem('siteLanguage') || 'ru';

// Функция для замены <br /> на пробелы в btn-text при ширине ≤768px
// ОТКЛЮЧЕНО: теперь br теги должны работать при 768px
if (typeof updateBtnTextsForMobile === 'undefined') {
  window['updateBtnTextsForMobile'] = function () {
    // Функция отключена - br теги должны работать при 768px
    return;
  }
}


// Функция для обновления текста info_p в зависимости от размера экрана
function updateInfoPText() {
  const infoP = document.querySelector('.info_p');
  if (infoP && window.translations && window.translations[currentLang]) {
    const t = window.translations[currentLang];
    
    // Определяем регион
    let currentRegion = 'Россия';
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
    if (saved) {
      try {
        const regionData = JSON.parse(saved);
        currentRegion = regionData.name;
      } catch (e) {
        // Если не удалось распарсить, используем значение по умолчанию
      }
    }
    
    const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
    const block8Text = isUzbekistan && t.block8_text_uzbekistan
      ? t.block8_text_uzbekistan
      : t.block8_text;
    
    if (block8Text) {
      infoP.innerHTML = block8Text;
      // Устанавливаем data-атрибут для CSS ::before (используется на десктопе)
      infoP.setAttribute('data-desktop-text', block8Text.replace(/<br\s*\/?>/gi, ' '));
    }
  }
}

// Добавляем обработчик resize для обновления текста info_p
let infoPResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(infoPResizeTimeout);
  infoPResizeTimeout = setTimeout(() => {
    updateInfoPText();
  }, 100);
});

// Вызываем updateInfoPText при загрузке страницы
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateInfoPText, 200);
  });
} else {
  setTimeout(updateInfoPText, 200);
}

window.addEventListener('load', () => {
  setTimeout(updateInfoPText, 100);
});

// Обработчик клика на кнопку языка
function initLanguageSwitcherDom() {
  const updateLangButtons = function(text) {
    // Обновляем кнопку в основном хедере
    const langButton = document.getElementById('langButton');
    if (langButton) {
      langButton.textContent = text;
    }
    
    // Обновляем кнопку в красном хедере (nav-bar)
    const navLangButton = document.getElementById('navLangButton');
    if (navLangButton) {
      // Ищем span внутри кнопки
      let langNavSpan = navLangButton.querySelector('.lang_nav');
      if (langNavSpan) {
        // Обновляем только текст внутри span
        langNavSpan.textContent = text;
      } else {
        // Если span не найден, проверяем, есть ли текст напрямую в элементе
        // Если есть дочерние элементы, очищаем и создаем span
        if (navLangButton.children.length > 0) {
          navLangButton.innerHTML = '';
        }
        const newSpan = document.createElement('span');
        newSpan.className = 'lang_nav';
        newSpan.textContent = text;
        navLangButton.appendChild(newSpan);
      }
    }
  };
  
  // Экспортируем функцию для использования в других местах
  window.updateLangButtons = updateLangButtons;
  
  // Функция переключения языка — перезагрузка страницы
  const switchLanguage = function(e) {
    if (e) {
      e.preventDefault();
    }
    
    const actualLang = currentLang || localStorage.getItem('siteLanguage') || 'ru';
    
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
    let regionName = 'Россия';
    if (saved) {
      try {
        const r = JSON.parse(saved);
        regionName = r.name;
      } catch (e) {
        console.error("Ошибка при чтении региона:", e);
      }
    }
    
    const currentPath = window.location.pathname;
    const pathMatch = currentPath.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
    const isUzbekistan = regionName === 'Узбекистан' || regionName === 'Uzbekistan';
    let newPath;
    
    if (actualLang === 'ru') {
      localStorage.setItem('siteLanguage', 'en');
      if (pathMatch) {
        const country = isUzbekistan ? 'uz' : (pathMatch[2] === 'uz' ? 'uz' : 'gb');
        const rest = pathMatch[3] || '/';
        newPath = '/en-' + country + rest;
      } else if (currentPath === '/' || currentPath === '/index.html') {
        newPath = isUzbekistan ? '/en-uz/' : '/en-gb/';
      } else {
        newPath = isUzbekistan
          ? currentPath.replace(/\/ru-ru\//g, '/en-uz/').replace(/\/ru-uz\//g, '/en-uz/')
          : currentPath.replace(/\/ru-ru\//g, '/en-gb/').replace(/\/ru-uz\//g, '/en-uz/');
        if (newPath === currentPath) {
          newPath = isUzbekistan
            ? currentPath.replace(/ru-ru/g, 'en-uz').replace(/ru-uz/g, 'en-uz')
            : currentPath.replace(/ru-ru/g, 'en-gb').replace(/ru-uz/g, 'en-uz');
        }
      }
    } else {
      localStorage.setItem('siteLanguage', 'ru');
      if (pathMatch) {
        const country = pathMatch[2] === 'uz' ? 'uz' : 'ru';
        const rest = pathMatch[3] || '/';
        newPath = '/ru-' + country + rest;
      } else if (currentPath === '/' || currentPath === '/index.html') {
        newPath = isUzbekistan ? '/ru-uz/' : '/ru-ru/';
      } else {
        newPath = currentPath.replace(/\/en-gb\//g, '/ru-ru/').replace(/\/en-uz\//g, '/ru-uz/');
        if (newPath === currentPath) {
          newPath = currentPath.replace(/en-gb/g, 'ru-ru').replace(/en-uz/g, 'ru-uz');
        }
      }
    }
    
    if (newPath && newPath !== currentPath) {
      window.location.href = newPath + (window.location.search || '');
    }
  };
  
  // Получаем кнопки для добавления обработчиков
  const langButton = document.getElementById('langButton');
  const navLangButton = document.getElementById('navLangButton');
  
  if (langButton) {
    langButton.addEventListener('click', switchLanguage);
  }
  
  // Добавляем обработчик для кнопки в красном хедере (nav-bar)
  if (navLangButton) {
    navLangButton.addEventListener('click', switchLanguage);
  }

  // Загружаем сохраненный язык при загрузке страницы
  // Проверяем URL для определения языка (en-gb, en-uz → en; ru-ru, ru-uz → ru)
  const currentPath = window.location.pathname;
  const urlLang = (currentPath.includes('/en-gb/') || currentPath.includes('/en-uz/')) ? 'en' : ((currentPath.includes('/ru-ru/') || currentPath.includes('/ru-uz/')) ? 'ru' : null);
  
  // Обновляем currentLang из localStorage или URL
  if (urlLang) {
    currentLang = urlLang;
    localStorage.setItem('siteLanguage', urlLang);
  } else {
    currentLang = localStorage.getItem('siteLanguage') || 'ru';
  }
  
  if (currentLang === 'en') {
    translatePage('en');
    updateLangButtons('RU');
    // Показываем карточки цен при загрузке EN-страницы (priceSlider может выполниться раньше)
    setTimeout(() => {
      if (typeof window.selectBlock12Campus === 'function') {
        const curCountryEl = document.getElementById('curCountry');
        const isUzbekistan = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
        const campus = isUzbekistan ? 'tashkent' : 'gorki';
        window.selectBlock12Campus(campus);
      }
    }, 100);
    setTimeout(() => {
      if (typeof window.selectBlock12Campus === 'function') {
        const curCountryEl = document.getElementById('curCountry');
        const isUzbekistan = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
        const campus = isUzbekistan ? 'tashkent' : 'gorki';
        window.selectBlock12Campus(campus);
      }
    }, 500);
  } else {
    // Инициализируем русский язык при загрузке
    translatePage('ru');
    updateLangButtons('ENG');
  }
  
  // Также обновляем текст кнопок после небольшой задержки, чтобы убедиться, что DOM готов
  setTimeout(() => {
    const savedLang = localStorage.getItem('siteLanguage') || 'ru';
    if (savedLang === 'en') {
      updateLangButtons('RU');
    } else {
      updateLangButtons('ENG');
    }
  }, 100);
  
  // Дополнительное обновление после полной загрузки страницы
  window.addEventListener('load', () => {
    setTimeout(() => {
      const savedLang = localStorage.getItem('siteLanguage') || 'ru';
      if (savedLang === 'en') {
        updateLangButtons('RU');
        // Показываем карточки цен на EN после полной загрузки (когда selectBlock12Campus точно доступен)
        const ensureBlock12Prices = () => {
          if (typeof window.selectBlock12Campus === 'function') {
            const curCountryEl = document.getElementById('curCountry');
            const isUzbekistan = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
            const campus = isUzbekistan ? 'tashkent' : 'gorki';
            window.selectBlock12Campus(campus);
          }
        };
        ensureBlock12Prices();
        setTimeout(ensureBlock12Prices, 200);
        setTimeout(ensureBlock12Prices, 500);
      } else {
        updateLangButtons('ENG');
      }
    }, 200);
  });
  
  // Обновляем название региона с учетом текущего языка после инициализации
  // Не перезаписываем, если URL уже указывает на Узбекистан (en-uz/ru-uz)
  const pathMatchForRegion = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
  const urlSaysUzbekistan = pathMatchForRegion && pathMatchForRegion[2] === 'uz';
  if (!urlSaysUzbekistan) {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
    if (saved) {
      try {
        const r = JSON.parse(saved);
        if (typeof window.updateRegion === 'function') {
          window.updateRegion(r);
        }
      } catch (e) {
        console.error("Ошибка при обновлении региона:", e);
      }
    }
  }
  
  // Обновляем btn-text при загрузке страницы
  updateBtnTextsForMobile();
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initLanguageSwitcherDom);
} else {
  initLanguageSwitcherDom();
}

